import { render, staticRenderFns } from "./TabelaCliente.vue?vue&type=template&id=45f9cfe2&"
import script from "./TabelaCliente.vue?vue&type=script&lang=ts&"
export * from "./TabelaCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports